"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserRoles = void 0;
const parseRoles_1 = require("./parseRoles");
function parseUserRoles(roles) {
    if (typeof roles === "string") {
        return (0, parseRoles_1.parseRoles)(roles);
    }
    return roles;
}
exports.parseUserRoles = parseUserRoles;
